import { SdsInputBase } from '../../input/_sds-input-base';
import { SdsFormControl } from '../../form-control/sds-form-control.lit';
import { html, render } from 'lit';
import { translate } from '../../utilities/translate';
export class MultilingualContainer {
    constructor(value, firstLanguage, createInputElement, getContentClass, updateValue, doneClickHandler, invalid, maxLength, showCount, autoResize, rows, maxRows, containerName, containerRequired, rtl) {
        this.multilingualContainer = document.createElement('div');
        this.contentContainer = document.createElement('div');
        this.footerContainer = document.createElement('div');
        this.inputs = [];
        this.handleShadowStyle = () => {
            if (this.contentContainerOverflows()) {
                if (this.contentContainer.scrollTop + this.contentContainer.clientHeight <
                    this.contentContainer.scrollHeight - MultilingualContainer.SHADOW_STYLE_OFFSET) {
                    this.footerContainer.classList.add('sds-multilingual-footer--has-shadow');
                }
                else {
                    this.footerContainer.classList.remove('sds-multilingual-footer--has-shadow');
                }
            }
            else {
                this.footerContainer.classList.remove('sds-multilingual-footer--has-shadow');
            }
        };
        this.copyHandler = (e) => {
            const control = e.target;
            const copyValue = control.firstElementChild.value;
            this.inputs.forEach(input => {
                input[1].value = copyValue;
                this.value[input[0]] = copyValue;
                if (input[1].parentElement) {
                    input[1].parentElement.setAttribute('label-icon', 'copy');
                    input[1].parentElement.setAttribute('iconaside', '');
                }
            });
            this.updateValue();
        };
        this.handleInputMultilingual = (e) => {
            const inputTarget = e.target;
            const language = this.getLanguageByInput(inputTarget);
            if (language) {
                this.value[language] = e.detail.value;
            }
            if (!this.value[language] && inputTarget.parentElement) {
                inputTarget.parentElement.setAttribute('label-icon', '');
            }
            if (this.value[language]) {
                inputTarget.invalid = false;
            }
            else if (this.invalid) {
                inputTarget.invalid = true;
            }
            this.updateValue();
        };
        this.value = value;
        this.firstLanguage = firstLanguage;
        this.createInputElement = createInputElement;
        this.getContentClass = getContentClass;
        this.updateValue = updateValue;
        this.doneClickHandler = doneClickHandler;
        this.invalid = invalid;
        this.maxLength = maxLength;
        this.showCount = showCount;
        this.autoResize = autoResize;
        this.rows = rows;
        this.maxRows = maxRows;
        this.multilingualContainer = document.createElement('div');
        this.inputs = [];
        this.containerName = containerName;
        this.containerRequired = containerRequired;
        this.rtl = rtl;
    }
    prepareMultilingualInput() {
        this.resetContainer();
        this.addLabelToContainer();
        this.addLanguageInputToContainer(this.firstLanguage);
        Object.keys(this.value)
            .filter(language => language !== this.firstLanguage)
            .forEach(language => this.addLanguageInputToContainer(language));
        this.appendContentToMultilingualContainer();
        this.addDoneButton();
    }
    addLabelToContainer() {
        if (this.containerName) {
            const label = document.createElement('div');
            const clippedContainer = document.createElement('sds-clipped-text');
            clippedContainer.setAttribute('basic', '');
            clippedContainer.setAttribute('text', this.containerName);
            label.append(clippedContainer);
            label.classList.add('sds-multilingual-label');
            if (this.containerRequired) {
                label.classList.add('sds-multilingual-label--required');
            }
            this.contentContainer.append(label);
        }
    }
    addLanguageInputToContainer(language) {
        this.contentContainer.append(this.createInputFormControl(language));
    }
    createInputFormControl(language) {
        const input = this.createInput(language);
        const control = this.createFormControl(language);
        control.append(input);
        this.addFormControlEventListeners(control);
        if (input.value) {
            control.labelIcon = 'copy';
            control.iconAside = true;
        }
        input.addEventListener(SdsInputBase.INPUT_EVENT, () => {
            if (input.value) {
                control.labelIcon = 'copy';
                control.iconAside = true;
            }
            else {
                control.labelIcon = '';
                control.iconAside = false;
            }
        });
        input.addEventListener('focus', () => {
            control.setAttribute('focused', language);
        });
        input.addEventListener('blur', () => {
            control.removeAttribute('focused');
        });
        return control;
    }
    createFormControl(language) {
        const control = document.createElement('sds-form-control');
        control.setAttribute('label', language);
        return control;
    }
    appendContentToMultilingualContainer() {
        this.multilingualContainer.append(this.contentContainer);
        this.addScrollHandler();
    }
    addScrollHandler() {
        this.contentContainer.addEventListener('scroll', this.handleShadowStyle);
    }
    addDoneButton() {
        this.footerContainer = document.createElement('div');
        this.footerContainer.classList.add('sds-multilingual-footer');
        this.multilingualContainer.append(this.footerContainer);
        render(html `<sds-button
                label="${translate('sds.multilingual.done')}"
                size="lg"
                type="primary"
                icon="check"
                @click="${this.doneClickHandler}"
            ></sds-button>`, this.footerContainer);
    }
    createInput(language) {
        const input = this.createInputElement();
        this.setInputAttributes(input, language);
        this.addInputEventListeners(input);
        this.inputs.push([language, input]);
        return input;
    }
    setInputAttributes(input, language) {
        var _a;
        input.setAttribute('value', this.value[language]);
        if ((_a = this.rtl) === null || _a === void 0 ? void 0 : _a.includes(language)) {
            input.setAttribute('dir', 'rtl');
        }
        if (!this.value[language] && this.invalid) {
            input.setAttribute('invalid', '');
            input.setAttribute('error-message', `${language} is required!`);
        }
        input.setAttribute('maxLength', `${this.maxLength}`);
        if (this.showCount) {
            input.setAttribute('show-count', '');
        }
    }
    addInputEventListeners(input) {
        input.addEventListener(SdsInputBase.INPUT_EVENT, this.handleInputMultilingual);
        input.addEventListener(SdsInputBase.TEXT_CLEARED, this.handleInputMultilingual);
    }
    addFormControlEventListeners(formControl) {
        formControl.addEventListener(SdsFormControl.ICON_ACTION_EVENT, this.copyHandler);
    }
    resetContainer() {
        this.inputs = [];
        this.multilingualContainer = document.createElement('div');
        this.contentContainer = document.createElement('div');
        this.contentContainer.classList.add('sds-multilingual-content');
        this.contentContainer.classList.add(this.getContentClass());
    }
    getContainer() {
        return this.multilingualContainer;
    }
    getLanguageByInput(i) {
        return (this.inputs.find(input => input[1] === i) || '')[0];
    }
    getInputByLanguage(language) {
        return (this.inputs.find(input => input[0] === language) || this.inputs[0])[1];
    }
    focusFirstInput() {
        this.inputs[0][1].focused = true;
    }
    contentContainerOverflows() {
        return this.contentContainer.scrollHeight > this.contentContainer.clientHeight;
    }
    getScrollBarWidth() {
        return this.contentContainer.offsetWidth - this.contentContainer.clientWidth;
    }
}
MultilingualContainer.SHADOW_STYLE_OFFSET = 20;
